import React, {
  createContext,
  useContext,
  useMemo,
  useState
} from "react";

export const SkillTableDataContext = createContext();

export const SkillTableDataProvider = ({ children }) => {
  const [contentDetailModal, setContentDetailModal] = useState(false);
  const [contentDetailData, setContentDetailData] = useState(null);
  const [skillDetailData, setskillDetailData] = useState(null);

  const value = useMemo(() => {
    return {
      contentDetailModal,
      setContentDetailModal,
      contentDetailData,
      setContentDetailData,
      skillDetailData,
      setskillDetailData,
    };
  }, [
    contentDetailModal,
    setContentDetailModal,
    contentDetailData,
    setContentDetailData,
    skillDetailData,
    setskillDetailData,
  ]);

  return (
    <SkillTableDataContext.Provider value={value}>
      {children}
    </SkillTableDataContext.Provider>
  );
};

export function useSkillTableData() {
  const context = useContext(SkillTableDataContext);
  if (context === undefined) {
    throw new Error("alert");
  }
  return context;
}
